import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  DataGridCustomPagination,
  displayDateFormatter,
} from "components/helpers";
import { getAppointmentsCount } from "apiHandler/actions";
import { addDays } from "date-fns";

import { useNavigate } from "react-router-dom";
import { useUserData } from "components/customHooks/userDataContext";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { DATE_FORMAT, getFormattedDate } from "utils/helper";

const AppointmentSummary = () => {
  const [loading, setLoading] = useState(false);
  const [start_dos, setStart_dos] = useState(new Date());
  const [end_dos, setEnd_dos] = useState(addDays(new Date(), 7));
  const [appointments, setAppointments] = useState([]);
  const navigate = useNavigate();
  const userData = useUserData();

  const onSearch = async () => {
    const payload = {
      search_criteria: {
        practice_id: userData.selected_practice,
        start_dos: displayDateFormatter(start_dos),
        end_dos: displayDateFormatter(end_dos),
      },
    };
    setLoading(true);
    const response = await getAppointmentsCount(payload);
    setLoading(false);
    if (response) setAppointments(response.map((r, i) => ({ ...r, id: i })));
  };

  useEffect(() => {
    onSearch();
  }, []);

  const columns = [
    {
      field: "dos",
      headerName: "DOS",
      flex: 1,
      renderCell: (e) => (
        <div
          onClick={() => {
            navigate("/appointments", {
              state: e.row,
            });
          }}
          className="button"
        >
          {getFormattedDate(e.value)}
        </div>
      ),
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
    },
    {
      field: "reminder_status",
      headerName: "Reminder Status",
      flex: 1,
      renderCell: (e) => <div>{e.value || "N/A"}</div>,
    },
    {
      field: "count",
      headerName: "Count",
      flex: 1,
    },
  ];

  return (
    <div
      className="provider-appointments-container margin-center"
      style={{ maxWidth: "900px" }}
    >
      <div className="calendar-header-count">
        <div className="cal-diff-search">
          <span>DOS From</span>
          <DesktopDatePicker
            format={DATE_FORMAT}
            placeholder={DATE_FORMAT}
            value={dayjs(start_dos)}
            onChange={(e) => setStart_dos(e)}
            slotProps={{ textField: { variant: "standard" } }}
          />
          <span>DOS To</span>
          <DesktopDatePicker
            format={DATE_FORMAT}
            placeholder={DATE_FORMAT}
            value={dayjs(end_dos)}
            onChange={(e) => setEnd_dos(e)}
            slotProps={{ textField: { variant: "standard" } }}
          />
          <button onClick={onSearch} className="blank-hover-btn">
            Search
          </button>
        </div>
      </div>
      <DataGrid
        rows={loading ? [] : appointments}
        columns={columns}
        autoHeight="true"
        disableRowSelectionOnClick
        pagination
        pageSize={50}
        density="compact"
        slots={{
          pagination: DataGridCustomPagination,
        }}
        loading={loading}
      />
    </div>
  );
};

export default AppointmentSummary;
